import { FC } from 'react';
import { CellProps, WithClassname } from '@jsonforms/core';
import merge from 'lodash/merge';
import moment from 'moment';
import { AdditionalProps } from '@components/uploadForm/Types/ControlConfiguration';

type ExtendedCellProps = CellProps &
  WithClassname & {
    value: moment.Moment | null;
    format: string;
    onChange: (timeString: string) => void;
    disabled: boolean;
    autoFocus: string;
    style?: { width: string } | Record<string, never>;
  };

type WrapperProps = CellProps & WithClassname & AdditionalProps

export const wrappedControlConfigurationCells = (
  controlWrapperFunc: (
    c: FC<CellProps & WithClassname & AdditionalProps>
  ) => void,
  Component: FC<WrapperProps>
) => {
  const AntdComponent: FC<
    CellProps & WithClassname & AdditionalProps
  > = props => {
    const { data, uischema, path, handleChange, config, format, ...restProps } =
      props;

    const appliedUiSchemaOptions = merge({}, config, uischema?.options || {});
    const inputStyle: { width: string } | Record<string, never> =
      !appliedUiSchemaOptions.trim ? { width: '100%' } : {};

    const onChange = (timeString: string) => handleChange(path, timeString);

    const componentProps: Partial<ExtendedCellProps> = {
      value: data ? moment(data, format) : null,
      format,
      onChange,
      disabled: !props.enabled,
      autoFocus: appliedUiSchemaOptions.focus,
      style: inputStyle,
    };

    return <Component {...props} {...componentProps} {...restProps} />;
  };

  return controlWrapperFunc(AntdComponent);
};
